import Modal, { ModalProps, ModalSize } from 'common/Modal/Modal';
import ModalFooter from 'common/Modal/ModalFooter';

export default Modal;

export type { ModalProps };

export { ModalSize, ModalFooter };
